import { render, staticRenderFns } from "./modal-box.vue?vue&type=template&id=228fa14c&scoped=true"
import script from "./modal-box.vue?vue&type=script&lang=js"
export * from "./modal-box.vue?vue&type=script&lang=js"
import style0 from "./modal-box.vue?vue&type=style&index=0&id=228fa14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fa14c",
  null
  
)

export default component.exports